import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ApiUrlBuilder } from '@/utils/UrlBuilder';

export function TradingServer <T> (requestConfig: RequestConfig): Promise<AxiosResponse<T>> {
  requestConfig.url = ApiUrlBuilder.build(requestConfig.url, requestConfig.urlParams);
  return axios(requestConfig);
}

interface RequestConfig extends AxiosRequestConfig {
  url: string;
  urlParams: { [key: string]: string };
  method: AxiosRequestConfig['method'];
}
